import { IGetAllCargoUseCase } from "../../../presentation/useCases/read/get_all_cargo_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IRhRepository } from "../../repositories/rh_repository";
import { Cargo } from "../../models/cargo";

/**
 * GetAllCargoUseCase
 */

export class GetAllCargoUseCase extends BasePaginatedUseCase<Cargo> implements IGetAllCargoUseCase {
  constructor(private readonly repository: IRhRepository) {
    super();
  }

  async getAllCargo(
    nome: string,
    atribuicoes: string,
    escolaridade: string,
    status: number,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllCargo(
      nome,
      atribuicoes,
      escolaridade,
      status,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
